import Image from "next/image";
import Link from "next/link";
import { NEXT_FRONTEND_URL, NEXT_IMAGE_CDN } from "@/src/lib/util/config";
import CustomChip from "@/src/lib/ui/customChip";

const FacilitesList = ({ row, isSpacing, index }) => {
    return (
        <Link href={`/facilities/${row?.urlSlug}`} title={row?.categoryName} passHref>
            <div
                className={`group relative md:p-2 border border-solid border-gray-200 hover:border-primary shadow-md text-black rounded-xl overflow-hidden ${
                    isSpacing ? "mx-3" : ""
                }`}
            >
                <div className="min-h-44 relative overflow-hidden rounded-t-xl">
                    <Image
                        src={`${NEXT_IMAGE_CDN}/${row?.cardImage}`}
                        alt={row?.categoryName}
                        width={0}
                        height={0}
                        sizes="(max-width: 768px) 100vw, 33vw"
                        className="w-full h-full object-cover rounded-t-xl group-hover:scale-105 transition-transform duration-300 ease-in-out"
                        //loading="lazy"
                        priority={index < 1} // 👈 Add priority only to the first image
                    />
                    <CustomChip
                        size="small"
                        label={
                            row?.categoryType == "scan"
                                ? "Radiology"
                                : row?.categoryType == "lab"
                                ? "Pathology"
                                : "Packages"
                        }
                        color="primary"
                        variant="contained"
                        className="text-xs rounded-xs absolute top-2 right-2 z-1"
                    />
                </div>

                {/* <p v className="bg-slate-700 p-2">
					{row?.categoryType}
				     </p> */}

                <h3 className="text-base font-semibold leading-3 mb-4 md:mt-2 mt-4 text-center">
                    {row?.categoryName}
                </h3>

                {/* <p className="text-sm text-gray-600">
						Total Care Checkup is one of the most popular health checkup
						packages at HOD.....
					</p> */}
            </div>
        </Link>
    );
};

export default FacilitesList;
